import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "value", "id", "disabled"];
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ListItem from '../ListItem';
import SelectContext from './SelectContext';
import { handleKeyboardClick } from '../../utils';
import useId from '../../hooks/useId';
export default function SelectOption(_ref) {
  var children = _ref.children,
      value = _ref.value,
      id = _ref.id,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(SelectContext),
      selectedValue = _useContext.value,
      onClick = _useContext.onClick;

  var generatedId = useId(id);

  var onOptionClick = function onOptionClick(e) {
    if (disabled) return;
    e.target.value = value;
    onClick(e);
  };

  var onOptionKeyboardClick = handleKeyboardClick(onOptionClick);
  return /*#__PURE__*/React.createElement(ListItem, _extends({}, props, {
    "data-value": value,
    disabled: disabled,
    role: "option",
    "aria-selected": value === selectedValue,
    onClick: onOptionClick,
    onKeyPress: onOptionKeyboardClick,
    id: generatedId,
    as: "div"
  }), children);
}
SelectOption.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  singleLine: PropTypes.bool,
  id: PropTypes.string
};
SelectOption.defaultProps = {
  disabled: false,
  singleLine: false,
  id: ''
};
SelectOption.SupportingText = ListItem.SupportingText;